import * as React from "react";

const Cube = (props) => (
  <svg
    width={props.width || "1em"}
    height={props.height || "1em"}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908ZM7 6.93078V12.9649L2 10.6316V4.80578L7 6.93078ZM13 10.6316V4.80578L8 6.93078V12.9649L13 10.6316ZM12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672L12.2719 4.02866Z"
      fill="currentColor"
    />
  </svg>
);

export default Cube;
